module.exports = __webpack_public_path__ + "img/dr.6b0f960f.jpg";